import { render } from "./MDBCollapse.vue?vue&type=template&id=d6d5e6d4"
import script from "./MDBCollapse.vue?vue&type=script&lang=js"
export * from "./MDBCollapse.vue?vue&type=script&lang=js"

import "./MDBCollapse.vue?vue&type=style&index=0&id=d6d5e6d4&lang=css"

import exportComponent from "/home/mdb/projects/mdb5-repos/vue/build-tool/dev/mdb-vue-dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__